import { z } from 'zod'

import {
  CONFIGS,
  FUNDS,
  INPUT_TYPES,
  INSTANCE_TAGS,
  REPORT_TYPES,
} from '@/components/forms/RunRiskCalibrationForm/enums'

// --------------------

export const allJobsSchema = z.object({
  input_type: z.literal(INPUT_TYPES.ALL_JOBS),
  value_date: z.iso.date(),
  instance_tag: z.enum(INSTANCE_TAGS),
  push_to_db: z.boolean(),
})

// --------------------

export const customStrategiesSchema = z.object({
  input_type: z.literal(INPUT_TYPES.CUSTOM_STRATEGIES),
  value_date: z.iso.date(),
})

// --------------------

export const voldivAdjustmentsSchema = z.object({
  input_type: z.literal(INPUT_TYPES.VOLDIV_ADJUSTMENTS),
  value_date: z.iso.date(),
})

// --------------------

export const calibrationSchema = z.object({
  input_type: z.literal(INPUT_TYPES.CALIBRATION),
  value_date: z.iso.date(),
  instance_tag: z.enum(INSTANCE_TAGS),
  push_to_db: z.boolean(),
  config: z.enum(CONFIGS),
})

// --------------------

export const defaultRiskSchema = z.object({
  input_type: z.literal(INPUT_TYPES.DEFAULT_RISK),
  value_date: z.iso.date(),
  instance_tag: z.enum(INSTANCE_TAGS),
  funds: z.array(z.enum(FUNDS)).min(1),
  config: z.enum(CONFIGS),
})

// --------------------

export const customRiskSchema = z.object({
  input_type: z.literal(INPUT_TYPES.CUSTOM_RISK),
  value_date: z.iso.date(),
  instance_tag: z.enum(INSTANCE_TAGS),
  config: z.enum(CONFIGS),
  reports_dct: z.record(z.string(), z.array(z.enum(REPORT_TYPES)).min(1)).refine((values) => {
    return Object.entries(values).some(([_fund_name, _reports]) => _reports.length > 0)
  }, 'At least one report for one fund must be selected.'),
})

// --------------------

export const derivedMetricsSchema = z.object({
  input_type: z.literal(INPUT_TYPES.DERIVED_METRICS),
  value_date: z.iso.date(),
})

// --------------------

export const schema = z.discriminatedUnion('input_type', [
  allJobsSchema,
  customStrategiesSchema,
  voldivAdjustmentsSchema,
  calibrationSchema,
  defaultRiskSchema,
  customRiskSchema,
  derivedMetricsSchema,
])

export type SchemaType = z.infer<typeof schema>
